module.exports = __webpack_public_path__ + "img/gbenga.58b13470.png";